import React from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  Fade,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

// Example icons:
import AddAlertIcon from '@mui/icons-material/AddAlert';
import EventIcon from '@mui/icons-material/Event';
import AssessmentIcon from '@mui/icons-material/Assessment';

const QuickActionMenu = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <IconButton onClick={handleClick} size="large" sx={{ color: 'white' }}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        TransitionComponent={Fade}
        PaperProps={{
          sx: { minWidth: 180 }
        }}
      >
        <MenuItem onClick={handleClose}>
          <ListItemIcon>
            <AddAlertIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="New Announcement" />
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <ListItemIcon>
            <EventIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Add Holiday" />
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <ListItemIcon>
            <AssessmentIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Generate Report" />
        </MenuItem>
      </Menu>
    </>
  );
};

export default QuickActionMenu;
